export const serviceOrderedI18nKeys = {
    Todo: 'REAL_ESTATE_AGENT.DASHBOARD.DETAIL.EOTS_BY_REAL_ESTATE_AGENT',
    Resend: 'RESEND',
    Confirm: 'RESEND.CONFIRM',
    Success: 'RESEND.SUCCESS',
};
